import { OrderRejectionReason } from '../../../../../services/exports/Constants';

export default {
  header: 'Bestellung stornieren',
  title: 'Niemals zu leichtfertig ablehnen!',
  text: 'If there’s a minor issue with the order, please call the customer and work it out.',
  reasons: {
    [OrderRejectionReason.ItemUnavailable]: 'Artikel nicht auf Lager',
    [OrderRejectionReason.ClosingSoon]: 'Geschäft ist geschlossen',
    [OrderRejectionReason.StoryBusy]: 'Das Geschäft ist zu sehr beschäftigt',
    [OrderRejectionReason.CustomerMistake]: 'Kunde ruft an, um zu stornieren',
    [OrderRejectionReason.DriverNotArrived]: 'Fahrer nicht angekommen',
  },
  buttons: {
    confirm: 'Bestätigen',
  },
};
